<ng-container *ngIf="cashFlow">
  <tandem-cash-flow-form [cashFlow]="cashFlow" mode="create" (submitted)="onCreate($event)" [cacheChanges]="!mostRecent" [user]="user"></tandem-cash-flow-form>
</ng-container>
